import { render, staticRenderFns } from "./ListItemShow.vue?vue&type=template&id=155ec2d8&scoped=true&"
import script from "./ListItemShow.vue?vue&type=script&lang=ts&"
export * from "./ListItemShow.vue?vue&type=script&lang=ts&"
import style0 from "./ListItemShow.vue?vue&type=style&index=0&id=155ec2d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155ec2d8",
  null
  
)

export default component.exports